import { getLocalizationById } from '@context/useMyRouting/helpers';
import Typography from '@mui/material/Typography';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { getCargo } from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/helpers';
import { HistoryRouteData } from '@pages/History/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getLocationLabel, mapShareCargoToOrderCargo } from './helpers';

/**
 * Пропсы компонента
 */
type RouteHistoryItemProps = {
  data: HistoryRouteData;
  baseData: RouteWidgetBaseParameters;
  langId: string;
};

/**
 * Сводка по расчету доставки.
 * getCargo внутри вызывает хуки, поэтому монтируем только после загрузки данных.
 */
export const RouteHistoryItem = ({ data, baseData, langId }: RouteHistoryItemProps) => {
  const { t } = useTranslation(['OrderList', 'Common']);
  const langCode = getLocalizationById(langId)?.countryCode;
  const { containers, units, trucks } = baseData;
  const { cargoType, cargoParams } = mapShareCargoToOrderCargo(data.params);

  const cargo = getCargo(cargoType, { containers, units, trucks }, cargoParams, langCode, langId);
  const startLabel = getLocationLabel(data, 'start', langId, t);
  const endLabel = getLocationLabel(data, 'end', langId, t);

  return (
    <div className={'order-product-component'}>
      <Typography variant={'h4'}>{`${startLabel} - ${endLabel}`}</Typography>
      <Typography variant={'body2'} className={'route-history-cargo'}>
        {`${t('OrderList:Cargo')}: ${cargo.join(', ')}`}
      </Typography>
    </div>
  );
};
